import { cn } from "@/lib/utils";
import PropTypes from "prop-types";
import CanvasLayout from "../Canvas/CanvasLayout";

/**
 * Simple layout container for chat interface with canvas mode support
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The main chat content
 * @param {string} props.className - Additional CSS classes
 */
export function ChatLayout({ children, className }) {
  return (
    <CanvasLayout className={cn("h-full w-full", className)}>
      {children}
    </CanvasLayout>
  );
}

ChatLayout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ChatLayout;
